/* eslint-disable no-use-before-define */
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Logo from '../../images/logo_white.svg';
import { useUserData } from '../../shared/hooks/useUserData';
import Layout from './Layout';
import '../style.css';

interface RightPanelContainerProps {
  children: ReactNode;
  type:
    | 'accessCode'
    | 'resetPassword'
    | 'requestAccessCode'
    | 'requestPasswordReset'
    | 'signup'
    | 'signin';
  page?: string;
}

export function RightPanelContainer({ children, type, page }: RightPanelContainerProps) {
  const showSignIn = type !== 'accessCode' && type !== 'signin';
  const showSignUp = type === 'signin';
  const showForgotAccessCode = type === 'accessCode';

  return (
    <Layout page={page}>
      <div id="right_container">
        <div className="frame">
          <OnboardingLogo />
          {children}
        </div>
        <Footer
          showForgotAccessCode={showForgotAccessCode}
          showSignIn={showSignIn}
          showSignUp={showSignUp}
        />
      </div>
    </Layout>
  );
}

interface FooterProps {
  showForgotAccessCode: boolean;
  showSignIn: boolean;
  showSignUp: boolean;
}

function Footer({ showForgotAccessCode, showSignIn, showSignUp }: FooterProps) {
  const { t } = useTranslation();

  return (
    <div className="lower_container bottom_padding">
      {showSignUp && (
        <p className="signin" id="sign-up">
          {t('R050')} <a href="/signup">{t('label.signup')}</a>
        </p>
      )}
      {showForgotAccessCode && (
        <p className="signin" id="find-code">
          {t('R077')} <a href="/find-code">{t('R079')}</a>
        </p>
      )}
      {showSignIn && (
        <p className="signin" id="sign-in">
          {t('R012')} <a href="/sign-in">{t('R011')}</a>
        </p>
      )}
      <p className="signin" id="need-help">
        {t('R075')}{' '}
        <a
          href="https://support.championhealth.co.uk/"
          target="_blank"
          rel="noreferrer"
          aria-label={`${t('R076')} (${t('opens_in_new_window')})`}
        >
          {t('R076')}
        </a>
      </p>
      <p className="signin" id="accessibility-statement">
        <Link to="/accessibility-statement">{t('accessibility.statement.title')}</Link>
      </p>
    </div>
  );
}

function OnboardingLogo() {
  const { userData } = useUserData();
  const { t } = useTranslation();

  if (userData?.logo) {
    return (
      <div className="company_logo">
        <img
          src={userData.logo}
          className="icon title_icon"
          alt={`${userData.clientName || t('onboarding.logo.alt')} ${t('logo')}`}
        />
      </div>
    );
  }

  return (
    <div className="logo">
      <img src={Logo} className="icon title_icon" alt={`Champion Health ${t('logo')}`} />
    </div>
  );
}
